export class Document {

    id: number;
    name: string;
    path: string;
    date;
    type: string;
    isValid: boolean = false;

    constructor(document) {
        this.id = document.id;
        this.name = document.file_name;
        this.path = document.file_path;
        this.date = document.date;
        this.type = document.type;
        
        if (this.name && this.path && this.date && this.type)
            this.isValid = true;
    }
}